<template>
  <div class="container">
    <WithLabel
      :max="max"
      :label="label"
      :value="modelValue"
      :showLabel="showLabel"
      :id="id"
    >
      <template v-slot:right>
        <slot name="right" />
      </template>
      <AppInput
        :id="id"
        v-model="localModelValue"
        @blurAfterChange="onBlur"
        :placeholder="placeholder"
        :type="type"
        :invalid="invalid"
        :error="error"
        :maxLength="maxLength"
        :disabled="disabled"
      />
    </WithLabel>
  </div>
</template>

<script>
import WithLabel from '@/../lib/components/commonComponents/WithLabel/WithLabel.vue';
import { nanoid } from 'nanoid';

export default {
  setup() {
    return {
      id: nanoid(),
    };
  },
  props: {
    modelValue: { type: null },
    label: { type: String },
    placeholder: { type: String },
    max: { type: String },
    maxLength: { type: String },
    invalid: { type: null },
    error: { type: String },
    disabled: {
      type: Boolean,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  computed: {
    localModelValue: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
        this.$emit('change', newValue);
      },
    },
  },
  methods: {
    onBlur() {
      this.$emit('blurAfterChange');
    },
  },
  components: {
    WithLabel,
  },
};
</script>

<style lang="scss" scoped>
.container {
  .label {
    margin-bottom: 6px;
    display: flex;
    justify-content: space-between;

    .title {
      font-weight: 600;
      font-size: 16px;
      line-height: 171%;
      color: #25262c;
    }

    .symbols {
      font-weight: 500;
      font-size: 12px;
      line-height: 171%;
      color: #989898;
    }
  }
}
</style>
